import {
  Schema,
  entityId,
  entityType,
  invitees,
  inviteHashes,
  picid,
  rights,
  shareableId,
  tripId,
} from './common_schema.js';

const id = Schema.Int;
const activities = Schema.Array(Schema.StrictString);
const cocampers = invitees;
const cover = Schema.String;
const duration = Schema.Int;
const groupSize = Schema.Int;
const locId = Schema.Default(Schema.Int, null);
const title = Schema.NotEmptyString;
const startDate = Schema.Date;
const dataset = Schema.NotEmptyString;

const properties = [
  'title',
  'activities',
  'startDate',
  'duration',
  'groupSize',
  'locId',
];

const fields = {
  shareableId,

  id,
  activities,
  cover,
  startDate,
  duration,
  groupSize,
  locId,
  title,

  tripId,
  entityType,
  rights,
};

const schema = {
  'clone': new Schema({
    id,
    activities,
    cocampers,
    cover,
    duration,
    groupSize,
    locId,
    startDate,
    title,
  }),
  'create': new Schema({
    activities,
    cocampers,
    cover,
    duration,
    groupSize,
    locId,
    startDate,
    title,
  }),
  'delete': new Schema({
    id,
  }),
  'share': new Schema({
    id,
    invitees,
  }),
  'share-or-revoke': new Schema({
    id,
    invitees,
    revokedInviteHashes: inviteHashes,
  }),
  'get-friends': new Schema({}),
  'get-property': new Schema({
    id,
    prop: Schema.Enum(...properties, 'cocampers'),
  }),
  'get-entities': new Schema({
    id,
  }),
  'get-trips': new Schema({}),
  'get-trip-pic': new Schema({
    picid,
  }),
  'pick-location': new Schema({
    startDate,
    duration,
    locId,
  }),
  'set-property': new Schema({
    id,
    activities: Schema.Optional(activities),
    duration: Schema.Optional(duration),
    groupSize: Schema.Optional(groupSize),
    locId: Schema.Optional(locId),
    startDate: Schema.Optional(startDate),
    title: Schema.Optional(title),
  }),
  'learn': new Schema({
    entityId,
  }),
  'retrain': new Schema({
    dataset,
  }),
};

export {
  schema as TripSchema,
  fields as TripSchemaFields,
  properties as TripProperties,
};
